<template>
  <b-col :xl="content.columns" cols="12">
    <div class="card">
      <LmComponentLoading v-if="loading"/>
      <div class="card-body">
        <a href="" class="d-none btn btn-sm btn-link float-right mb-3">Export
          <i class="mdi mdi-download ml-1"></i>
        </a>
        <h4 class="header-title mt-2">{{ content.tableTitle }}</h4>

        <div class="table-responsive">
          <table class="table table-centered table-hover mb-0">
            <tbody>
              <tr v-for="(tr, index) in content.rows" :key="index">
                <td v-for="(objContent, key, index) in tr" :key="index">
                  <h5 class="font-14 mb-1 font-weight-normal">{{ objContent }}</h5>
                  <span class="text-muted font-13">{{ key.replace(/([A-Z])/g, ' $1').trim().replace(/_/g, ' ') }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div> <!-- end table-responsive-->
      </div> <!-- end card-body-->
    </div> <!-- end card-->
  </b-col>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: ['content'],
  computed: {
    ...mapState('settings', ['loading'])
  }
}
</script>

<style lang="sass" scoped>
  .table-hover
    tbody
      tr
        &:hover
          background: #f1f3fa
  .table
    td,
    th
      padding: 15px
    td
      span
        display: block
        text-transform: lowercase
        &::first-letter
          text-transform: capitalize
</style>
